export const OAUTH_PENDING_KEY = "chlk_oauth_pending";
export const OAUTH_PENDING_TTL_MS = 120_000;

export type SocialProvider = "google" | "apple";

export interface OAuthPendingPayload {
  provider: SocialProvider;
  nonce: string;
  ts: number;
}

export function buildOAuthStartUrl(
  provider: SocialProvider,
  nonce: string,
  baseUrl: string = window.location.origin
): string {
  const params = new URLSearchParams({ provider, nonce });
  // Hash survives Office dialog + serve cleanUrls redirect; query string may not on Mac
  return `${baseUrl}/oauth-start.html#${params.toString()}`;
}

export function stageOAuthParams(provider: SocialProvider, nonce: string): void {
  const payload: OAuthPendingPayload = { provider, nonce, ts: Date.now() };
  localStorage.setItem(OAUTH_PENDING_KEY, JSON.stringify(payload));
}

export function parseOAuthParamsFromHash(
  hash: string
): { provider: string | null; nonce: string | null } {
  const trimmed = hash.startsWith("#") ? hash.slice(1) : hash;
  if (!trimmed) return { provider: null, nonce: null };
  const params = new URLSearchParams(trimmed);
  return { provider: params.get("provider"), nonce: params.get("nonce") };
}

export function parseOAuthParamsFromSearch(
  search: string
): { provider: string | null; nonce: string | null } {
  const params = new URLSearchParams(search);
  return { provider: params.get("provider"), nonce: params.get("nonce") };
}

export function readOAuthParamsFromStorage(
  raw: string | null,
  now: number = Date.now()
): { provider: string | null; nonce: string | null } {
  if (!raw) return { provider: null, nonce: null };
  try {
    const data = JSON.parse(raw) as OAuthPendingPayload;
    if (now - data.ts >= OAUTH_PENDING_TTL_MS) return { provider: null, nonce: null };
    return { provider: data.provider, nonce: data.nonce };
  } catch {
    return { provider: null, nonce: null };
  }
}
